<template lang="pug">
  div
    lessonHeader
    stepTitle
    approach
    indication
    question(v-if="currentStep.state === false")
    feedback(v-else)
    button(v-if="currentStep.state == false" v-on:click="currentStep.state = !state") Evaluar
    buttonSend(v-else @click="currentStep.state = false")
    lessonFooter
</template>

<script>

import { mapGetters } from 'vuex';
import stepTitle from '@/components/step-title/step-title'
import approach from '@/components/approach/approach'
import indication from '@/components/indication/indication'
import question from '@/components/question/question'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import lessonHeader from "@/components/lesson-header/lesson-header";
import buttonSend from "@/components/button-send/button-send";
import feedback from "@/components/feedback/feedback"
export default {
  name: 'Question',
  components: {
    stepTitle,    
    lessonFooter,
    lessonHeader,
    question,
    buttonSend,
    approach,
    indication,
    feedback
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
	data(){
		return {
			state: false 
		}
	},
	mounted: function(){
		this.state = false;
	},
	methods:{
		change(){
			this.state = true;
		}
  }
}
</script>

<style scoped>
button
{
	background-color: #0b4d9c;
	color: white;
	width: 150px;
	height: 50px;
}
</style>
